// Utils
import { convertPxsToRems } from '@openbank/cf-ui-framework';

const LANDING_OPTIONS_MODAL_FEATURES_ICON_PROPS = {
    height: convertPxsToRems({ pixels: 32 }),
    width: convertPxsToRems({ pixels: 32 }),
  },
  LANDING_OPTIONS_MODAL_FEATURES_DESCRIPTION_PROPS = {
    'data-testid': 'landing-options-modal-features-description',
  };

export {
  LANDING_OPTIONS_MODAL_FEATURES_ICON_PROPS,
  LANDING_OPTIONS_MODAL_FEATURES_DESCRIPTION_PROPS,
};
